import { render, staticRenderFns } from "./edit-brand.vue?vue&type=template&id=54d46ae4&scoped=true&"
import script from "./edit-brand.vue?vue&type=script&lang=js&"
export * from "./edit-brand.vue?vue&type=script&lang=js&"
import style0 from "./edit-brand.vue?vue&type=style&index=0&id=54d46ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d46ae4",
  null
  
)

export default component.exports